/**
 * Suporte da Fórmula MED pelo WhatsApp — o botão Ajuda da topbar e a entrada do menu da conta.
 *
 * Número provisório (15/09/2026, decisão do usuário): trocar aqui troca nos dois lugares.
 * Formato do wa.me: DDI + DDD + número, só dígitos.
 */
export const WHATSAPP_DO_SUPORTE = '556435590229';

/** O link já abre a conversa com a versão escrita: é a primeira coisa que o suporte pergunta. */
export function linkDoSuporte(versao: string): string {
    const texto = `Olá! Preciso de ajuda com a Fórmula MED (versão ${versao}).`;
    return `https://wa.me/${WHATSAPP_DO_SUPORTE}?text=${encodeURIComponent(texto)}`;
}

/* Abre no clique, sem `await` antes: fora do gesto da pessoa o navegador bloqueia a aba. */
export function abrirSuporte(versao: string): void {
    window.open(linkDoSuporte(versao), '_blank', 'noopener,noreferrer');
}
